import gql from 'graphql-tag';

const CAMPAIGN_ORDERS_AGGREGATE_BYDATE = gql`
  query campaignOrdersAggregateByDate($where: CampaignOrderWhereInput!) {
    campaignOrders(where: $where) {
      id
      name
      startDate
      endDate
      IONumber
      productCode
      type
      advertiser {
        name
        CPAcronym
        level
        parentOrg {
          CPAcronym
          level
          createdAt
        }
      }
      aggregateData {
        completeAttributionSummary
      }
    }
  }
`;

export default CAMPAIGN_ORDERS_AGGREGATE_BYDATE;
